export const PRACTICE_REGISTRATION_ROLE_PRACTICE = 'Practice';
export const PRACTICE_REGISTRATION_ROLE_SALES = 'Sales';
